export default "__VITE_ASSET__B732jxiC__"